import { render, staticRenderFns } from "./SeasonCards.vue?vue&type=template&id=066dda2f&scoped=true"
import script from "./SeasonCards.vue?vue&type=script&lang=js"
export * from "./SeasonCards.vue?vue&type=script&lang=js"
import style0 from "./SeasonCards.vue?vue&type=style&index=0&id=066dda2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066dda2f",
  null
  
)

export default component.exports